import { Route } from 'types/route.type';
import ViewSite from './view-site';
import ListSites from 'views/planning-prognosis/list-sites';

export const routes: Route[] = [
  {
    path: '/planning-prognosis/sites/:siteTab',
    component: ListSites,
    id: 'planningPrognosis.navigation.listSites',
  },
  {
    path: '/planning-prognosis/sites/:siteTab/:localSiteId/:fishGroupTab',
    component: ViewSite,
  },
];
